import Controller, { inject as controller } from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class HotelOverviewSettingsController extends Controller {
  @service router;

  @controller('hotel.overview') overviewDashboardController;

  @action
  closeODSettingsModal(triggerAlertsRefresh = false) {
    this.router.legacyTransitionTo('hotel.overview');

    if (triggerAlertsRefresh) {
      // Update the alerts data on modal close, but ideally only when the settings have actually changed
      this.overviewDashboardController.relaunchAlertsDataRequest();
    }
  }
}
